import $ from "jquery";

class Reload {
    constructor() {
        this.bindClick();
    }

    bindClick() {
        $(document).ready(() => {
            $("[data-reload]").on("click", () => {
                window.location.reload();
            });
        })
    }
}

export default new Reload();

